<template>
    <BtnFlotWA />

  <section>
    <Navbar />
  </section>

  <Categorias /> 

  <section style="padding-top: 0px;">
    <Footer />
  </section>

</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import '@vuepic/vue-datepicker/src/VueDatePicker/style/main.scss';
import GoogleMap from '@/components/GoogleMap.vue';
import { useI18n } from 'vue-i18n';
import BtnFlotWA from '@/components/BtnFlotWA.vue';
import Categorias from '@/components/Categorias.vue';


export default {
  setup () {
    const { t } = useI18n;
    return { t };
  },
  name: 'Home',
  components: {
    Navbar, Footer,GoogleMap, BtnFlotWA , Categorias,
  data() {
    return {
      date: null,
      language :  null,showPopup: true,

      items: [
          
        ],
    };
  },

  data: () => ({

  }

  ),

  methods: {
    
    
  },
  created() {
    
  },
  mounted(){
    window.scrollTo(0, 0);
  }
}
}

//Estrellas en cursor
  if (window.innerWidth > 768) {
  let lastMove = 0;

  document.addEventListener("mousemove", (e) => {
    const now = Date.now();

    // limita cantidad para que no se sature
    if (now - lastMove < 10) return;
    lastMove = now;

    const sparkle = document.createElement("div");
    sparkle.className = "sparkle";

    // ligera variación para que se vea natural
    const offsetX = (Math.random() - 0.5) * 10;
    const offsetY = (Math.random() - 0.5) * 10;

    sparkle.style.left = e.clientX + offsetX + "px";
    sparkle.style.top = e.clientY + offsetY + "px";

    document.body.appendChild(sparkle);

    setTimeout(() => {
      sparkle.remove();
    }, 1000);
  });
}


</script>

<style>
.footer-wave-path {
    fill: #8dd7fc;
}

:root {
  --background-dark: #11146d;
  --spacing-s: 8px;
  --spacing-m: 16px;
  --spacing-l: 24px;
  --spacing-xl: 32px;
  --spacing-xxl: 64px;

  --text-light: rgba(255, 255, 255, 0.75);
  --text-lighter: rgba(221, 244, 255, 0.95);

  --width-container: 1200px;
}

/* SECTION */
.hero-section {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 4rem 1rem;
  padding-top: 6%;
  background: #8dd7fc;
}

/* GRID RESPONSIVE */
.card-grid {
  display: grid;
  width: 100%;
  max-width: var(--width-container);
  gap: 24px;
  /* RESPONSIVE AUTOMÁTICO */
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}

/* CARD */
.card {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 24px;
  text-decoration: none;
  background: #0008ff;
}

/* RELACIÓN RESPONSIVA */
.card::before {
  content: "";
  display: block;
  padding-bottom: 130%;
}

/* IMAGE */
.card__background {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  border-radius: inherit;
  transform: scale(1);
  transition:
    transform 0.3s ease,
    filter 0.3s ease;
  filter: brightness(0.75);
}

/* HOVER */
.card:hover .card__background {
  transform: scale(1.05);
}

.card-grid:hover > .card:not(:hover) .card__background {
  filter: brightness(0.5) blur(4px);
}

/* CONTENT */
.card__content {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  /*padding: 1.5rem;*/
  padding: -0.5rem;
  z-index: 2;
}

/* TEXT */
.txt__card{
  background-color: #baecffd4;

}

.card__category {
  color: #11146d;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.card__heading {
  color: #BAECFF;
  font-size: clamp(1.3rem, 2vw, 2.3rem);
  font-weight: 900;
  line-height: 1.2;
  text-shadow: 2px 2px 20px rgba(0, 0, 0, 0.3);
  background-color: #11146dd5;
  font-family: "Magistral_Bold";
}


/* MOBILE */

@media (max-width: 500px) {
  .hero-section {
    padding: 2rem 1rem;
  }

  .card::before {
    padding-bottom: 120%;
  }
  
}
</style>